<template>
  <div class="lc">
    <div class="lc__top">
      <div class="lc__title page__header_title">ЭТО<b>ПРОСЧЕТ</b></div>
      <div class="lc__name">{{ managerName }}</div>
    </div>

    <ul class="lc__list">
      <MainOrder
        v-for="item in orderListVisible"
        :item="item"
        :key="item.order"
      />
      <!--      <li v-for="item in orderListVisible" :key="item.order" class="lc__item">-->
      <!--        <button type="button" class="lc__btn" @click="openOrder(item.order)">-->
      <!--          Заявка #<span>{{ formatId(item.number) }}</span> для-->
      <!--          <span>{{ formatName(item.user) }}</span> от-->
      <!--          {{ item.time }}-->
      <!--        </button>-->
      <!--        <button type="button" class="lc__delete" @click="deleteOrder(item)">-->
      <!--          Удалить-->
      <!--        </button>-->
      <!--      </li>-->
    </ul>
    <button class="lc__add btn btn-block" type="button" @click="addOrder">
      <span class="icon icon-plus"></span>
    </button>

    <pagination
      v-if="orderList.length > perPage"
      :records="orderList.length"
      v-model="page"
      :per-page="perPage"
      :options="{
        texts: {
          count:
            'Заявки с {from} до {to}, всего {count}|Заявок {count}|Заявка одна'
        }
      }"
    />

    <pre v-if="false" style="font-size: 1rem">
      <code>
        {{ $store.getters.allState.currentOrder }}
        <!--        {{ orderList }}-->
        <!--        {{$store.getters.getOptions}}-->
      </code>
    </pre>
  </div>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import wNumb from "wnumb";
import MainOrder from "@/components/Main-order";

export default {
  name: "Main",
  components: { MainOrder },
  data() {
    return {
      page: 1,
      perPage: 10
    };
  },
  computed: {
    managerName() {
      return this.$store.getters.manager.name;
    },
    orderList() {
      return this.$store.getters.orderList;
    },
    orderListVisible() {
      let pos = this.perPage * this.page;
      return [...this.orderList].reverse().slice(pos - this.perPage, pos);
    }
  },
  methods: {
    addOrder() {
      this.$store.dispatch("addOrder");
    }
  }
};
</script>
